import EditCreditCardModal from '@anm/components/subscription/EditCreditCardModal';
import useErrorControls from '@anm/hooks/useErrorControls';
import { FC } from 'react';

import vtConfig from '../../../config';
import useErrors from '../UpgradeUserSubscription/hooks/useErrors';

import useSubmitCardHandler from './hooks/useSubmitCardHandler';

export type EditCreditCardProps = {
  children: string;
  onModalClose: () => void;
};

const { ssl } = vtConfig();

const EditCreditCard: FC<EditCreditCardProps> = ({
  children,
  onModalClose
}) => {
  const [
    handleEditCreditCard,
    isEditCreditCardPending
  ] = useSubmitCardHandler();

  const errors = useErrors();
  const controlledErrors = useErrorControls(errors, 'init-reset');

  return (
    <EditCreditCardModal
      sslId={ssl}
      errors={controlledErrors}
      isSubmitPending={isEditCreditCardPending}
      onSubmit={handleEditCreditCard}
      onModalClose={onModalClose}
    >
      {children}
    </EditCreditCardModal>
  );
};
export default EditCreditCard;
